/* HomepageCommon.styles.ts generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _5 = "@media not all and (min-width:64rem){._1fbnidpf{margin-right:0}}";
const _4 = "@media (min-width:48rem){._1svyap9k{margin-bottom:var(--ds-space-800)}}";
const _3 = "._otyrgosd{margin-bottom:var(--ds-space-500)}";
import { media } from '@atlaskit/primitives/responsive';
import { FluidContainer } from '@atlassian/mpac-primitives';
const _2 = "@media (min-width:64rem){._isu468cl{margin-bottom:90pt}}";
const _ = "._otyr1epz{margin-bottom:var(--ds-space-1000,5pc)}";
export const SectionWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_otyr1epz _isu468cl", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SectionWrapper.displayName = 'SectionWrapper';
}
export const HeroWrapper = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_3, _4]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_otyrgosd _1svyap9k", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  HeroWrapper.displayName = 'HeroWrapper';
}
export const FeaturedSectionWrapper = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = FluidContainer,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_5]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1fbnidpf", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  FeaturedSectionWrapper.displayName = 'FeaturedSectionWrapper';
}